<template>
    <div>
      <!-- <PCNavbar/>
      <TitleComponent/>
      <ProductFeatures/>
      <FunctionFeatures/>
      <SmartDevices/> -->
      <!-- <UserCases/> -->
      <!-- <CallMe/> -->
    </div>
  </template>
  
  <script>
  import PCNavbar from '@/components/navbar/index'
  import TitleComponent from '@/components/titleComponent/index'
  import ProductFeatures from '@/components/productFeatures/index'
  import FunctionFeatures from '@/components/functionFeatures/index'
  import SmartDevices from '@/components/smartDevices/index'
  import UserCases from '@/components/user_cases/index'
  import CallMe from '@/components/callme/index'
  
  export default {
    components: {
      PCNavbar,
      TitleComponent,
      ProductFeatures,
      FunctionFeatures,
      SmartDevices,
      UserCases,
      CallMe,
    },
  }
  </script>
  
  <style lang="scss" scoped>

  </style>